import { GetStaticPaths, GetStaticProps } from 'next';

import ApiService from '@/lib/api';
import BlogList from '@/components/Blog/BlogList';
import MainLayout from '../../../layouts/MainLayout';
import { withSiteName } from '@/utils/pageTitle';

export const getStaticPaths: GetStaticPaths = async () => {
  const apiService = new ApiService();
  const blogsLength = await apiService.getBlogPostsLength();
  const slugList = Array.from({ length: blogsLength - 1 }, (v, i) => i + 2);

  return {
    paths: slugList.map((route) => ({
      params: { slug: route.toString() },
    })),
    fallback: true,
  };
};

export const getStaticProps: GetStaticProps = async ({ params: { slug } }) => {
  const postsPerPage = 6;
  const parsedSlug = Number(slug);
  const start = postsPerPage * (parsedSlug - 1);
  const apiService = new ApiService();
  const [data, blogsLength, menuData, { footer, blogList }] = await Promise.all([
    apiService.getBlogPostsList(start, start + (postsPerPage - 1)),
    apiService.getBlogPostsLength(),
    apiService.getMenuData(),
    apiService.getMiscData(),
  ]);
  const numPages = Math.ceil(blogsLength / postsPerPage);

  return {
    props: {
      posts: data,
      blogList,
      menuData,
      footer,
      currentPage: parsedSlug,
      numPages,
    },
    revalidate: 3600,
  };
};

const CulturePage = ({ posts, currentPage, numPages, footer, menuData, blogList }) => {
  const ogUrl = `https://foxbox.com/blog/page/${currentPage}`;
  // Every page of the archive used to ship the same <title> as /blog, which is the
  // duplicate-title pattern the SEO audit behind FOX2-77 flags. This route only ever
  // renders page 2 and up (getStaticPaths starts at 2), so the label is always a
  // composed one — the Studio counter never measured it, and suffixing is safe.
  const baseTitle = blogList?.blogListMetaTitle || blogList?.heading;
  const metaTitle = withSiteName(baseTitle ? `${baseTitle} (Page ${currentPage})` : undefined);
  return (
    <MainLayout
      bgWhite={false}
      navIsFixed={false}
      navIsDark={false}
      ogUrl={ogUrl}
      footer={footer}
      menuData={menuData}
      metaTitle={metaTitle}
      metaDescription={blogList?.blogListMetaDescription}
    >
      <BlogList posts={posts} numPages={numPages} currentPage={currentPage} blogListCopy={blogList} />
    </MainLayout>
  );
};

export default CulturePage;
